import { requests } from '.';
import config from '@/config';
export var UrlType;
(function (UrlType) {
    UrlType["INVOICE"] = "invoice";
    UrlType["RECEIPTS"] = "receipts";
    UrlType["PAYMENT_LINK"] = "payment-link";
})(UrlType || (UrlType = {}));
export const InvoiceService = {
    generateUrl: (params) => requests(config.INVOICE_SERVICE_URL).get(`/invoices/gen-url`, { params }),
};
